import React from 'react';
import '../../styles/content.scss';

const RichText = ({ content }) => {
  return (
    <div className="rich-text-container content-formatting">
      <div dangerouslySetInnerHTML={{ __html: content.content }} />
    </div>
  );
};

export default RichText;
